<template>
    <section id="contact" class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h2><i class="fas fa-address-book left-align"></i>Contact</h2>
                <p>
                    <em>This website is maintained constantly to provide the best user experience — so I would highly appreciate your feedback.
                    <br/>Feel free to leave any comments, report any issues or even if you just want to get in touch.</em>
                    <br/><a href="#" data-toggle="modal" data-target="#disclaimer" @click="openDisclaimer()">How is any information submitted below being used?</a>
                </p>

                <form class="needs-validation" novalidate @submit.prevent="sendMessage()">
                    <div class="form-row">
                        <div class="col-md-6 mb-4">
                            <label for="userName">Your name (*)</label>
                            <div class="invalid-feedback" :class="{'shown': invalidInputs.includes('name')}">
                                <i class="fas fa-exclamation-circle"></i>
                                Please enter your name
                            </div>
                            <input type="text" class="form-control" id="userName" placeholder="Name" 
                                v-model="input.name" @blur="validateInput('name')">
                        </div>
                        <div class="col-md-6 mb-4">
                            <label for="userEmail">Your email address (*)</label>
                            <div class="invalid-feedback" :class="{'shown': invalidInputs.includes('email')}">
                                <i class="fas fa-exclamation-circle"></i>
                                Please enter a valid email address
                            </div>
                            <input type="email" class="form-control" id="userEmail" placeholder="Email address" 
                                v-model="input.email" @blur="validateInput('email')">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-md-12 mb-4">
                            <label for="messageSubject">Message subject</label>
                            <input type="text" class="form-control" id="messageSubject" placeholder="Subject" 
                                v-model="input.subject">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-md-12 mb-4">
                            <label for="messageBody">Message or comments</label>
                            <textarea class="form-control" id="messageBody" rows="4" 
                                placeholder="Leave you message or comments here..." v-model="input.message"></textarea>
                        </div>
                    </div>

                    <em>(*) Required fields</em>
                    <button class="btn btn-white float-right" type="submit">Send message</button>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
const config = require('@/../helpers/config')
const sgMail = require('@sendgrid/mail');
sgMail.setApiKey(config.SendGridAPIKey);

import { mapActions } from 'vuex'

export default {
    data: function(){
        return {
            input: {
                name: '',
                email: '',
                subject: '',
                message: ''
            },
            invalidInputs: []
        }
    },
    methods: {
        ...mapActions(['showDisclaimerModal', 'showMessageStatus']),
        openDisclaimer: function(){
            this.showDisclaimerModal(true);
        },
        validEmailChecker: function (emailAddress) {
            let checker = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return checker.test(emailAddress);
        },
        validateInput: function (inputId){
            let matchingIdx = this.invalidInputs.findIndex(id => id === inputId);
            
            if (inputId === "all"){ // Check all fields
                this.validateInput("name");
                this.validateInput("email");
            }
            else if (inputId === "name"){ // Check whether name is empty or not
                if (this.input.name.trim().length < 1){
                    if (matchingIdx === -1)
                        this.invalidInputs.push(inputId);
                }
                else {
                    if (matchingIdx !== -1)
                        this.invalidInputs.splice(matchingIdx, 1);
                }
            }
            else if (inputId === "email"){ // Check whether email address is in a valid format or not
                if (!this.validEmailChecker(this.input.email)){
                    if (matchingIdx === -1)
                        this.invalidInputs.push(inputId);
                }
                else {
                    if (matchingIdx !== -1)
                        this.invalidInputs.splice(matchingIdx, 1);
                }
            }
        },
        sendMessage: async function(){
            await this.validateInput("all");

            if (this.invalidInputs.length > 0)
                return;
            
            try {
                const templateId = 'd-48948f438f5040d6a5ff8cf2d60c9610';
    
                const templateData = {
                    SUBJECT: this.input.subject,
                    SENDER_NAME: this.input.name,
                    SENDER_EMAIL: this.input.email,
                    MESSAGE: this.input.message
                };
    
                const personalisations = {
                    to: 'jv@sunarja.com',
                    "dynamic_template_data": templateData
                };
    
                const msg = {
                    template_id: templateId,
                    from: {
                        "email": 'no-reply@jv.sunarja.com',
                        "name": "JV.Sunarja.com"
                    },
                    personalizations: [personalisations]
                };
    
                console.dir(msg, { depth: null });
                const res = await sgMail.send(msg);
    
                console.log(res);
                this.clearError();
                this.showMessageStatus({shown: true, isMessageSent: true});
            }
            catch (ex){
                console.log(ex);
                this.showMessageStatus({shown: true, isMessageSent: false});
            }
        },
        clearError: function(){
            this.invalidInputs = [];
        }
    },
}
</script>

<style lang="scss" scoped>
section {
    background-color: $colour-blue-primary;
    color: $colour-white;
}

.col-md-12 {
    padding: 0 10vw;

    p {
        text-align: center;
        margin: 2rem 0;
    }

    a {
        color: $colour-blue-light;
    }

    &.mb-4 {
        padding: 0;
    }
}
</style>
